import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$accountsFactory} from "../../$accounts.factory";
import {SplitService} from "../../../commons/services/split-service.service";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class DemandAccountMultiSelectListCtrl implements IController {

  billingAccountIds: any;
  selectedIds: string[];
  branchIds: string[];
  depotIds: string[];
  excludeIds: string[];
  isShowBranchFilter: boolean;
  isPickupEnabled: boolean;
  isDropoffEnabled: boolean;
  noPickUp: boolean;
  noDropOff: boolean;
  isAllowSelectPerTask: boolean;
  ngPlaceholder: any;

  onChangeFilterNoPickUp: Function;
  onChangeFilterNoDropOff: Function;
  onTogglePickup: Function;
  onToggleDropoff: Function;
  onChange: Function;

  private accountsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: string;
  private selectedKeys: any;
  public excludedMap: any;
  public isSelectAll: boolean;
  public tags: string[] = [];
  public subFilterQueryMap;
  public selectedFirstAccount: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $accounts: $accountsFactory, private $infiniteScroll, private $log, private splitService: SplitService,
              private commonsService: CommonsService) {
  }

  $onInit() {
    this.accountsRef = this.$accounts();
    this.loadLimit = 20;
    this.branchIds = !_.isUndefined(this.branchIds) ? this.branchIds : [];

    if (!this.selectedIds) {
      this.selectedIds = []
    }
    this.accountsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.accountsRef, this.loadLimit, {getFullData: true});
    this._setSelectedAccounts();

    this.subFilterQueryMap = {
      tagType: 'Account'
    }
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
      if (!changes.selectedIds.isFirstChange()) {
        this._setSelectedAccounts();
      }
    }
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  onToggle(accountId, isSelected) {
    this.onChange({
      accountIds: isSelected ? _.concat(this.selectedIds || [], [accountId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== accountId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  onBranchIdsChange(branchIds) {
    this.branchIds = branchIds ? branchIds : [];
    this._reload();
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({accountIds: []});
    } else {
      this.onChange({accountIds: this.infiniteScroll?.getItems()?.map((account) => account.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(account => account.id), this.selectedIds);
    return this.isSelectAll;
  }

  onChangeFilters(tags) {
    this.tags = tags;
    this._reload();
  }

  private _reload() {
    this.accountsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _setSelectedAccounts() {
    if (!!this.selectedIds?.length) {
      this.accountsRef.$asyncValues(this.selectedIds[0])
        .then((accounts) => {
          this.selectedFirstAccount = accounts[0];
          this._setSelectedText();
        });
    } else {
      this.selectedFirstAccount = undefined;
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    this.selectedText = !!this.selectedFirstAccount ?
      `${this.selectedFirstAccount.name} +${this.selectedIds.length - 1}` : undefined;
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      billingAccountId: this.billingAccountIds,
      query: this.queryString,
      isDemand: true,
      branchIds: this.branchIds,
      depotIds: this.depotIds,
      tags: this.tags,
      sort: 'name,asc'
    };
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('demandAccountMultiSelectList', {
    bindings: {
      selectedIds: '<',
      branchIds: '<?',
      billingAccountIds: '<?',
      depotIds: '<?',
      excludeIds: '<?',
      isShowBranchFilter: '<?',
      isPickupEnabled: '<?',
      isDropoffEnabled: '<?',
      noPickUp: '<?',
      noDropOff: '<?',
      ngPlaceholder: '@?',
      isAllowSelectPerTask: '<?',
      onChange: '&',
      onTogglePickup: '&',
      onToggleDropoff: '&',
      onChangeFilterNoPickUp: '&',
      onChangeFilterNoDropOff: '&'
    },
    template: require('./demand-account-multi-select-list.html').default,
    controller: DemandAccountMultiSelectListCtrl
  });
